module.exports = __webpack_public_path__ + "img/gm.5d5fe5d7.svg";